import { useOrientedLayoutMode, type OrientedLayoutMode } from '@/hooks/useDeviceLayout'

export type CompareLayoutMode = OrientedLayoutMode

export function useCompareLayoutMode(): CompareLayoutMode {
  return useOrientedLayoutMode()
}

export function getCompareGridClassName(mode: CompareLayoutMode, count: number): string {
  switch (mode) {
    case 'desktop':
      return `grid grid-cols-${Math.min(Math.max(count, 3), 4)} gap-3`
    case 'tablet-landscape':
      return count >= 3 ? 'grid grid-cols-3 gap-3' : 'grid grid-cols-2 gap-3'
    case 'tablet-portrait':
      return 'flex gap-3 overflow-x-auto pb-2'
    case 'phone-landscape':
      return 'grid grid-cols-2 gap-3'
    case 'phone-portrait':
      return 'grid grid-cols-1'
    default:
      return 'grid grid-cols-1 gap-3'
  }
}

export function getCompareColumnClassName(mode: CompareLayoutMode): string {
  if (mode === 'tablet-portrait') {
    return 'min-w-[45%] shrink-0'
  }

  return 'min-w-0'
}
